"use strict";

export class UIExtensions {
    static hookOnObject(thisObject,otherObject) {
        thisObject.rect.position.x = -otherObject.width;
    }
}